/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import Layout from '@layout/index';
import { Decimal } from '@cosmjs/math';
import { Grid } from '@mui/material/';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import classnames from 'classnames';
import TooltipMUI, { tooltipClasses } from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import QuestionIcon from '@assets/AirQualityPage/question_icon.svg';
import InfoIcon from '@assets/AirQualityPage/info_icon.svg';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import Button, { buttonClasses } from '@mui/material/Button';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import moment from 'moment';

import { useStores } from '@stores';
import { BEARS } from '@api';
import BeeSpinnerLoading from '@components/BeeSpinnerLoading';
import { TOOLTIP_DELAY } from '@constants/system';
import { GOLDEN_BEE_ADDRESSES } from 'src/constants/goldenBeeClub';
import { numberWithSeparator, floorRounding } from '@utils';

import styles from './goldenBeePage.module.scss';

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    color: '#4F4F4F',
    backgroundColor: '#FFFFFF',
    '&:active': {
      color: '#FFFFFF',
      backgroundColor: '#2D9CDB',
    },
    '@media (hover: hover)': {
      [`&.${buttonClasses.root}:hover`]: {
        color: '#FFFFFF',
        backgroundColor: '#2D9CDB',
      },
    },
  },
  [`&.${buttonClasses.disabled}`]: {
    color: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0.12);',
    boxShadow: 'none',
  },
}));

const QualityTooltip = styled(({ className, ...props }) => (
  <TooltipMUI {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 16,
  },
}));

const GoldenBeePage = observer(() => {
  const stores = useStores();
  const textRef = useRef(null);

  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    let newAddresses = [];
    const addressesGBC = JSON.parse(JSON.stringify(GOLDEN_BEE_ADDRESSES));
    addressesGBC.forEach((addrMonth, index) => {
      newAddresses.push(
        addrMonth.map(address => {
          if (index > 1) {
            return { address, isNew: !addressesGBC[index-1].includes(address) }
          }
          return { address, isNew: false }
        })
      );
    });
    newAddresses = newAddresses.reverse();
    setAddresses(newAddresses);
  }, []);

  // useEffect(() => {
  //   const resizeFont = () => {
  //     const textElement = textRef.current;
  //     if (!textElement) return;
  //     console.log(' textElement.parentNode >> ',  textElement.parentNode);
  //     const parentWidth = textElement.parentNode.clientWidth;
  //     const textWidth = textElement.scrollWidth;
  //     console.log('size >>> ', {textWidth , parentWidth});
  //     if (textWidth > parentWidth) {
  //       const fontSize = parseInt(window.getComputedStyle(textElement).fontSize, 10);
  //       console.log('fontSize >> ', fontSize);
  //       const newFontSize = fontSize - 2;
  //       console.log('newFontSize >>> ', newFontSize);
  //       textElement.style.fontSize = `${newFontSize}px`;
  //     }
  //   };

  //   window.addEventListener('resize', resizeFont);
  //   resizeFont();

  //   return () => {
  //     window.removeEventListener('resize', resizeFont);
  //   };
  // }, []);


  const options = {
    responsive: true,
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Blocks height',
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Air count',
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: true,
        text: 'Air count',
      },
      tooltip: {
        enabled: true,
        position: 'nearest',
        // external: externalTooltipHandler //! externalTooltipHandler
        callbacks: {
          label(tooltipItem) {
            return `Air count: ${floorRounding(tooltipItem.parsed.y)}`;
          },
        },
      },
    },
  };

  /* Air Quality Tooltip logic */
  const [openAirQualityTooltip, setOpenAirQualityTooltip] = useState(false);
  const [airQualityTimerId, setAirQualityTimerId] = useState(null);
  const handleAirQualityTooltipClose = () => {
    setOpenAirQualityTooltip(false);
  };
  const handleAirQualityTooltipOpen = () => {
    setOpenAirQualityTooltip(true);
    clearTimeout(airQualityTimerId);
    const currentTimerId = setTimeout(() => handleAirQualityTooltipClose(), TOOLTIP_DELAY);
    setAirQualityTimerId(currentTimerId);
  };

  /* Air Count Tooltip logic */
  // const [openAirCountTooltip, setOpenAirCountTooltip] = useState(false);
  // const [AirCountTimerId, setAirCountTimerId] = useState(null);
  // const handleAirCountTooltipClose = () => {
  //   setOpenAirCountTooltip(false);
  // };
  // const handleAirCountTooltipOpen = () => {
  //   setOpenAirCountTooltip(true);
  //   clearTimeout(AirCountTimerId);
  //   const currentTimerId = setTimeout(() => handleAirCountTooltipClose(), TOOLTIP_DELAY);
  //   setAirCountTimerId(currentTimerId);
  // };

  return (
    <Layout>
      <Grid
        container
        sx={{ maxWidth: '1660px', width: '100%' }}
        p={{ xs: '28px 30px 0', sm: '20px 60px 0', lg: '20px 100px 0', xl: '20px 130px 0' }}
      >
        <div className={styles.TitleSection}>
          <p className={styles.GoldenBeeTitle}>Golden Bee Club</p>
          {/* <div className={styles.ConditionClubInfo}>
            <div className={styles.AirQualityTableTitleText}>
              Conditions for joining: Need 3000 CONEs in staking
            </div>
          </div> */}
        </div>
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4, lg: 6 }}
          sx={{ width: '100%' }}
          mb={{ xs: '20px', sm: '30px', lg: '50px' }}
        >
          {addresses.map((addressesMonth, index) => {
            if (addressesMonth && addressesMonth.length === 0) return false;
            const month = moment().month(11-index).format('MMMM'); // 11-index because reverse array
            const uniqCount = addressesMonth.filter(item => item.isNew).length;

            return (
              <Grid item xs={12} lg={6} key={`${month}`}>
                <div className={styles.AirQualityTable}>
                  <div className={styles.MonthTableTitleText}>
                    {month} 2023 ({addressesMonth.length})
                    {month === 'March' && (
                      <ClickAwayListener onClickAway={handleAirQualityTooltipClose}>
                        <div>
                          <QualityTooltip
                            PopperProps={{
                              disablePortal: true,
                            }}
                            open={openAirQualityTooltip}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={`The new number of members is ${uniqCount}`}
                          >
                            <img
                              src={QuestionIcon}
                              alt="question_icon"
                              className={styles.QuestionIcon}
                              onClick={() => handleAirQualityTooltipOpen()}
                            />
                          </QualityTooltip>
                        </div>
                      </ClickAwayListener>
                    )}
                  </div>
                  {/* <div className={styles.AirQualityTableTitle}>
                    <p className={styles.AirQualityTableTitleParameters}>{month} 2023 ({addressesMonth.length})</p>
                  </div> */}
                  <div className={styles.AirInfoBlock}>
                    <div className={styles.AirInfoBlockTitles}>
                      {addressesMonth.map((player) => {
                        return (
                          <p
                            ref={textRef}
                            key={`${player.address}_${month}`}
                            className={classnames(player.isNew && styles.NewPlayerClub)}
                          >
                            {player.address}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Layout>
  );
});

export default GoldenBeePage;
